<label class="eidos-input-boolean" [ngClass]="inputClass" [attr.for]="inputId">
  <input type="checkbox"
    [id]="inputId"
    [disabled]="disabled"
    [(ngModel)]="value"
    (ngModelChange)="valueChanged($event)" />
  <ng-content></ng-content>
</label>
